module.exports = __webpack_public_path__ + "img/song-sparrow.03bafc9c.jpg";